import {
  updateError,
  clearError,
  updateNotifList,
  updateCurNotifDetails,
  updateContactList,
  updateNotifInternal,
  updateCurContact,
  updateRegCodesList,
  updateContactNames,
  updateStandbyInspectorsList,
  updateCurStandbyInspector,
  updatePermissions,
} from './updateActions';

export {
  updateError,
  clearError,
  updateNotifList,
  updateCurNotifDetails,
  updateContactList,
  updateNotifInternal,
  updateCurContact,
  updateRegCodesList,
  updateContactNames,
  updateStandbyInspectorsList,
  updateCurStandbyInspector,
  updatePermissions,
};
